<template>
        <v-dialog v-model="confirmModel" max-width="600" persistent>
            <v-card class="background-2 round-card">
                <v-card-title primary-title class="subtitle-1 background-2">{{ mainTitle }}</v-card-title>
				<v-divider></v-divider>
                <v-card-text style="min-height: 100px;" class="pt-4 body-2">{{ secondTitle }}</v-card-text>
				<slot></slot>
                <v-divider></v-divider>

                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn text :color="cancel.color" @click.native.stop="$emit('update:confirmModel', false)" >{{ cancel.label }}
                    </v-btn>
                    <v-btn v-if="exit" text :color="exit.color ? exit.color : 'error'" @click.native.stop="atExit()" >{{ exit.label ? exit.label : 'Esci' }}
                    </v-btn>
                    <v-btn v-if="atConfirm" text :color="confirm.color" @click.native.stop="executeAtConfirm" :loading="loading">{{ confirm.label }}
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
</template>

<script>
export default {
	name: 'confirm-dialog',
	props: {
		confirmModel: Boolean,
		mainTitle: {
			default: 'Sei sicuro di procedere con questa azione?',
			type: String
		},
		secondTitle: {
			default: 'Questa azione è irreversibile',
			type: String,
		},
		cancel: {
			default: () => { 
				return {
					color: 'primary',
					label: 'Annulla',
				}
			},
			type: Object,
		},
		exit: {
			default: null,
			type: Object,
		},
		confirm: {
			default: () => {
				return {
					color: 'info',
					label: 'Salva',
				}
			},
			type: Object,
		},
		atConfirm: {
			default: null,
			type: Function
		},
		atExit: {
			default: null,
			type: Function
		},
	},

	data() {
		return {
			loading: false,
		}
	},

	methods: {
		executeAtConfirm() {
			this.loading = true
			this.atConfirm()
			this.$emit('update:confirmModel', false)
			setTimeout(() => {
				this.$set(this, 'loading', false)
			}, 1500)
		}
	},
}
</script>
